export default function ClipboardPlus() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="clipboard-plus">
                <path
                    id="Icon"
                    d="M13.332 3.33332C14.107 3.33332 14.4945 3.33332 14.8124 3.41851C15.6751 3.64968 16.349 4.32355 16.5802 5.18628C16.6654 5.50419 16.6654 5.89168 16.6654 6.66666V14.3333C16.6654 15.7335 16.6654 16.4335 16.3929 16.9683C16.1532 17.4387 15.7707 17.8212 15.3003 18.0608C14.7656 18.3333 14.0655 18.3333 12.6654 18.3333H7.33203C5.9319 18.3333 5.23183 18.3333 4.69705 18.0608C4.22665 17.8212 3.8442 17.4387 3.60451 16.9683C3.33203 16.4335 3.33203 15.7335 3.33203 14.3333V6.66666C3.33203 5.89168 3.33203 5.50419 3.41722 5.18628C3.64838 4.32355 4.32225 3.64968 5.18498 3.41851C5.5029 3.33332 5.89039 3.33332 6.66536 3.33332M9.9987 14.1667V9.16666M7.4987 11.6667H12.4987M7.9987 4.99999H11.9987C12.4654 4.99999 12.6988 4.99999 12.877 4.90916C13.0338 4.82927 13.1613 4.70178 13.2412 4.54498C13.332 4.36672 13.332 4.13337 13.332 3.66666V2.99999C13.332 2.53328 13.332 2.29992 13.2412 2.12166C13.1613 1.96486 13.0338 1.83738 12.877 1.75748C12.6988 1.66666 12.4654 1.66666 11.9987 1.66666H7.9987C7.53199 1.66666 7.29863 1.66666 7.12037 1.75748C6.96357 1.83738 6.83609 1.96486 6.75619 2.12166C6.66536 2.29992 6.66536 2.53328 6.66536 2.99999V3.66666C6.66536 4.13337 6.66536 4.36672 6.75619 4.54498C6.83609 4.70178 6.96357 4.82927 7.12037 4.90916C7.29863 4.99999 7.53199 4.99999 7.9987 4.99999Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
